module.exports = __webpack_public_path__ + "img/buy-bg.1f1e6437.png";